/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq1a1Inputs */

const zh_pricing_faq1a1 = /** @type {(inputs: Pricing_Faq1a1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费版每天可使用 3 次 AI 对话，可以体验基础互动组件。适合初次了解 StudyOS 的用户。`)
};

const en_pricing_faq1a1 = /** @type {(inputs: Pricing_Faq1a1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Free plan includes 3 AI conversations per day and access to basic interactive components. It's perfect for getting to know StudyOS.`)
};

const es_pricing_faq1a1 = /** @type {(inputs: Pricing_Faq1a1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El plan Gratis incluye 3 conversaciones IA por día y acceso a componentes interactivos básicos. Es perfecto para conocer StudyOS.`)
};

/**
* | output |
* | --- |
* | "The Free plan includes 3 AI conversations per day and access to basic interactive components. It's perfect for getting to know StudyOS." |
*
* @param {Pricing_Faq1a1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_faq1a1 = /** @type {((inputs?: Pricing_Faq1a1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq1a1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_faq1a1(inputs)
	if (locale === "en") return en_pricing_faq1a1(inputs)
	return es_pricing_faq1a1(inputs)
});
export { pricing_faq1a1 as "pricing_faq1A" }